import { LegalLayout, LegalSection } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function CustomerDataPolicyPage() {
  return (
    <LegalLayout
      eyebrow="Policies"
      title="Customer Data Policy"
      description={`How ${siteConfig.companyName} collects, secures, and governs customer data.`}
    >
      <LegalSection>
        <p>
          This Customer Data Policy explains the principles{" "}
          {siteConfig.companyName} follows when collecting, storing,
          processing, and sharing customer data as part of providing our
          lending services. It should be read alongside our{" "}
          <a href="/privacy" className="font-semibold text-brand-purple underline">
            Privacy Policy
          </a>
          , which covers your individual rights in more detail.
        </p>
      </LegalSection>

      <LegalSection heading="Data We Collect">
        <p>
          To assess loan eligibility and service your account, we collect
          identity and contact details, financial information (such as
          bank statements and income details), device and usage data from
          the app, and information from credit bureaus and other
          authorized third parties with your consent.
        </p>
      </LegalSection>

      <LegalSection heading="Purpose of Collection">
        <p>
          Customer data is collected strictly for purposes connected to our
          services — evaluating loan applications, verifying identity,
          disbursing and servicing loans, preventing fraud, meeting
          regulatory and compliance obligations, and improving our
          products. We do not collect data beyond what is reasonably
          required for these purposes.
        </p>
      </LegalSection>

      <LegalSection heading="Data Security">
        <p>
          Customer data is protected using industry-standard technical and
          organizational safeguards, including encryption in transit and at
          rest, access controls limiting data visibility to authorized
          personnel on a need-to-know basis, and regular security reviews.
          Access to sensitive financial data is logged and monitored.
        </p>
      </LegalSection>

      <LegalSection heading="Data Sharing">
        <p>
          Customer data is shared only where necessary — with the lending
          partner(s) disbursing your loan, credit bureaus for credit
          history checks, service providers who support our operations
          under confidentiality obligations, and regulators or law
          enforcement where required by law. We do not sell customer data
          to third parties for marketing purposes.
        </p>
      </LegalSection>

      <LegalSection heading="Data Retention">
        <p>
          Customer data is retained for as long as your account remains
          active, and thereafter for the period required to meet our legal,
          regulatory, and accounting obligations, after which it is
          securely deleted or anonymized.
        </p>
      </LegalSection>

      <LegalSection heading="Your Rights">
        <p>
          You may request access to the personal data we hold about you,
          ask us to correct inaccurate information, or request deletion of
          your data where it is no longer required for a lawful purpose. To
          exercise these rights, please contact us
          {siteConfig.email ? (
            <>
              {" "}
              at{" "}
              <a
                href={`mailto:${siteConfig.email}`}
                className="font-semibold text-brand-purple underline"
              >
                {siteConfig.email}
              </a>
            </>
          ) : null}
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
